module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'tracking/base' && templateVars.config ?
				templateVars.config :
				{
	"systems": {
		"ar": {
			"ru": {
				"piwik": {
					"id": 0
				},
				"inspectlet": {
					"id": 0
				},
				"yandex": {
					"id": 51220022,
					"trackGoals": true,
					"userVisitedGoalID": "userVisited"
				},
				"google": {
					"id": "UA-37889039-4"
				}
			},
			"en": {
				"piwik": {
					"id": 0
				},
				"inspectlet": {
					"id": 0
				},
				"yandex": {
					"id": 48756929,
					"trackGoals": true,
					"userVisitedGoalID": "userVisited"
				},
				"google": {
					"id": "UA-118784024-2"
				}
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/tracking/.variant/base/config.yaml
// module id = 84
// module chunks = 0